import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { addIcons } from "ionicons";
import * as allIcons from "ionicons/icons";

import { AppModule } from "./app/app.module";
import { initSentry } from "./app/sentry";
import { environment } from "./environments/environment";

// Register every ionicon statically so ion-icon never does a runtime SVG fetch.
// The esbuild `application` builder breaks ionicons' automatic URL resolution
// (icons exist under /svg but ion-icon can't resolve the path → "Could not load
// icon"). addIcons registers each key under its kebab-case alias too, so
// name="file-tray-full-sharp" resolves.
addIcons(allIcons as unknown as Record<string, string>);

if (environment.production) {
  enableProdMode();
}

initSentry();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error("err #13sd2 " + err));
